import { Enums } from '@configur-tech/upit-core-types';
import { cloneDeep } from 'lodash';
import { FC, useContext } from 'react';
import { useDispatch } from 'react-redux';
import styled, { ThemeContext } from 'styled-components';
import useList from '../../../../hooks/list/UseList';
import {
  StageBodyText,
  StageInner,
  StageWrapper,
  StyledBodySubHeader,
  StyledInput,
  StyledTextArea,
} from '../../../../main/theme';
import { fetchListSuccess } from '../../../../store/list';
import { updateActiveListSubStage } from '../../../../store/list-stage';
import { ListCreateSubStage } from '../../../../store/list-stage/initial-state';
import ActionBar from '../../../ActionBar/ActionBar';
import FeatureButton, {
  FeatureButtonSize,
} from '../../../FeatureButton/FeatureButton';
import StateManagedInput from '../../../StateManagedInput/StateManagedInput';

const NAME_FIELD = 'name';
const DESCRIPTION_FIELD = 'description';
const NEXT_STAGE = ListCreateSubStage.VALUES;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.margin.xlarge};
`;

const ListItemNameStage: FC = () => {
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const { list, listAccessLevel } = useList();

  const handleChange = (field: string, val: string | string[]) => {
    const cloned = cloneDeep(list);
    cloned[field] = val;
    dispatch(
      fetchListSuccess({
        entity: cloned,
        accessLevel: listAccessLevel || Enums.AccessLevel.MANAGE,
      }),
    );
  };

  return (
    <StageWrapper>
      <StageInner>
        <Section>
          <StyledBodySubHeader>List Name</StyledBodySubHeader>
          <StageBodyText>
            Enter an easily identifiable name for your new list.
          </StageBodyText>

          {list && (
            <StateManagedInput
              disabled={false}
              placeholder={'Enter your list name'}
              initialValue={list?.name || ''}
              style={{ marginBottom: themeContext.margin.xxlarge }}
              onChange={(value) => {
                handleChange(NAME_FIELD, value);
              }}
            />
          )}

          <StyledBodySubHeader>Description</StyledBodySubHeader>
          <StageBodyText>
            Briefly, what are you trying to achieve with this list?
          </StageBodyText>
          <StyledTextArea
            minRows={5}
            maxRows={10}
            placeholder={'Enter a description'}
            value={list?.description || ''}
            onChange={(event) =>
              handleChange(DESCRIPTION_FIELD, event.target.value)
            }
          />
        </Section>
      </StageInner>

      <ActionBar
        text={`Ready to go?`}
        primaryButton={
          <FeatureButton
            isDisabled={!list?.name.length}
            action={() => dispatch(updateActiveListSubStage(NEXT_STAGE))}
            size={FeatureButtonSize.WIDE}
            color={themeContext.colors.general.green}
            text={'Continue to Options'}
          />
        }
      />
    </StageWrapper>
  );
};

export default ListItemNameStage;
